import { useParams } from "react-router-dom";
import { reportBySlug } from "@/content/research/registry";
import { chartSvg } from "@/lib/researchChart";
import { useSeo } from "@/lib/seo";

const SITE = "https://99tests.com";

export default function ResearchEmbed() {
  const { slug, chartId } = useParams();
  const report = reportBySlug(slug);
  const chart = report && (report.charts || []).find((c) => c.id === chartId);
  useSeo({
    title: chart ? chart.title : "Chart",
    path: `/embed/research/${slug}/${chartId}`,
    noindex: true,
  });

  if (!report || !chart) {
    return <div style={{ padding: 16, fontFamily: "Arial, sans-serif" }}>Chart not found.</div>;
  }

  const svg = chartSvg(chart, { width: 600, height: 400 });
  return (
    <div data-testid="research-embed" style={{ margin: 0, padding: 12, fontFamily: "Arial, Helvetica, sans-serif" }}>
      <div style={{ maxWidth: 600 }} dangerouslySetInnerHTML={{ __html: svg }} />
      <p style={{ fontSize: 12, color: "#3a4656", marginTop: 6 }}>
        Source: <a href={`${SITE}/research/${report.slug}`}>99tests {report.title}</a>
      </p>
    </div>
  );
}
